const EXPORT = 'Export'
const ALL_LOANS = 'All Loans'
const VIEW_TRANSACTIONS = 'View Transactions'
const Title = 'Pending Disbursement'
const UPCOMINGPAYMENT = 'Upcoming Interest payments'
export { ALL_LOANS, EXPORT, VIEW_TRANSACTIONS, Title, UPCOMINGPAYMENT }
